import { EquipmentTypes, Truck } from '@numeo/types-core'

export const tempTruckData: Omit<Truck, '_id'> = {
    mainInfo: '',
    truckId: '',
    equipment: {
        type: EquipmentTypes.CLASSES,
        values: [],
    },
    length: '',
    weight: '',
    deadHeadOrigin: '',
    deadHeadDestination: '',
    fullPartial: 'BOTH',
    excludedStates: [],
    avoidWinterRoads: false,
    restrictions: [],
    isPermitted: {
        hazmat: false,
        tanker: false,
        doubleTripleTrailers: false,
        combinationEndorsements: false,
        canadaOperatingAuthority: false,
        mexicoOperatingAuthority: false,
        oversizeOverweight: false,
        hazardousWasteRadiological: false,
    },
    security: {
        tsa: false,
        twic: false,
        heavyDutyLock: false,
        escortDrivingOK: false,
        crossBorderLoads: false,
    },
}

export const getEmptyTruckData = (): Omit<Truck, '_id'> => ({
    mainInfo: '',
    truckId: '',
    equipment: {
        type: EquipmentTypes.CLASSES,
        values: [],
    },
    length: '',
    weight: '',
    deadHeadOrigin: '',
    deadHeadDestination: '',
    fullPartial: 'BOTH',
    excludedStates: [],
    avoidWinterRoads: false,
    restrictions: [],
    isPermitted: {
        hazmat: false,
        tanker: false,
        doubleTripleTrailers: false,
        combinationEndorsements: false,
        canadaOperatingAuthority: false,
        mexicoOperatingAuthority: false,
        oversizeOverweight: false,
        hazardousWasteRadiological: false,
    },
    security: {
        tsa: false,
        twic: false,
        heavyDutyLock: false,
        escortDrivingOK: false,
        crossBorderLoads: false,
    },
})
